import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import { setNewFilters } from "../../redux/filtersSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

// Barra di ricerca testuale "espansa": sostituisce le tre voci Dove/Con chi/Quando
// dentro la SearchBar quando l'utente tocca la lente (richiesta cliente 2026-07-30,
// la lente da sola veniva scambiata per il pulsante di invio delle tre domande).
export default function StringSearch({ onClose }) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const inputRef = useRef(null);
    const [searchInput, setSearchInput] = useState('');

    // Focus automatico all'apertura: l'utente ha appena toccato la lente per scrivere
    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const sendSearch = (e) => {
        e.preventDefault();
        const value = searchInput.trim();
        if (value === '') return;
        dispatch(setNewFilters({ search: value }));
        onClose?.();
        navigate('/all-activities');
    }

    return (
        // `py-3` allinea l'altezza della barra espansa a quella di default (le tre voci
        // Dove/Con chi/Quando hanno lo stesso padding verticale).
        // Gli `!` sovrascrivono gli stili globali di `input` in index.css (padding/bordo/font-size)
        <form onSubmit={sendSearch} className="w-full flex items-center gap-2 py-3">
            {/* Freccia e lente sono centrate in due box di pari altezza: allineate fra loro
                nonostante le dimensioni diverse del glifo */}
            <button
                type="button"
                onClick={onClose}
                aria-label={t('StringSearch.cancel')}
                className="flex items-center justify-center w-6 h-6 text-neutral-400"
            >
                <i className="fi fi-rr-angle-small-left text-2xl leading-none"></i>
            </button>
            <span className="flex items-center justify-center w-6 h-6">
                <i className="fi fi-br-search text-[#225424] text-lg leading-none"></i>
            </span>
            <input
                ref={inputRef}
                type="search"
                enterKeyHint="search"
                placeholder={t('StringSearch.placeholder')}
                className="!flex-1 !min-w-0 !border-0 !p-0 !text-base !bg-transparent focus:!outline-none"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
            />
            <button type="button" onClick={onClose} className="text-[#225424] whitespace-nowrap px-1">
                {t('StringSearch.cancel')}
            </button>
        </form>
    )
}
